export const DEPRECATED_SIDE_BAR_LINKS = [
  "/users/messages",
  "/users/payments",
  "/users/events",
  "/users/editProfile",
  "/users/consumables"
];
